module.exports = __webpack_public_path__ + "img/deskshelf15.a28f452a.jpg";